var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5513_9673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.192708 35.4244C0.986979 19.5512 12.5469 5.68018 27.7318 1.42541C47.0755 -3.99615 67.2448 6.51025 73.9792 25.3095C78.5286 38.0112 75.8802 52.6757 66.9948 62.7801L70.9974 66.7843C72.6615 65.1894 74.1458 62.7697 76.7526 64.3515L99.3229 86.907L100.003 88.0843V89.6478C99.6953 89.9193 99.6042 90.2899 99.3229 90.6293C97.375 92.9838 92.9818 97.3455 90.6328 99.3241C90.2943 99.6087 89.9219 99.6922 89.651 100.003H88.0885L86.9115 99.3241L64.3646 76.7452C62.7839 74.1375 65.2031 72.6522 66.7969 70.9869L62.7943 66.9827C52.4766 76.0587 37.6224 78.5619 24.7526 73.7747C11.7786 68.9456 1.85417 56.7295 0.377604 42.8637L0 40.6032V35.7193L0.192708 35.427V35.4244ZM38.0859 70.2847C55.8854 70.2847 70.3151 55.8498 70.3151 38.0425C70.3151 20.2351 55.8854 5.80025 38.0859 5.80025C20.2865 5.80025 5.85677 20.2351 5.85677 38.0425C5.85677 55.8498 20.2865 70.2847 38.0859 70.2847ZM70.8828 75.0903L88.7708 92.9838L92.987 88.7655L75.099 70.872L70.8828 75.0903Z",
    fill: "#E0EBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4275 22.8609C50.3051 22.6259 49.1853 22.8243 48.3416 23.6048L38.1645 33.7562L37.8884 33.6753L27.7218 23.5187C24.6723 21.1903 21.1827 24.5654 23.5499 27.6925L33.7817 37.9823L33.7009 38.2589L23.3494 48.6218C21.391 51.5792 24.5759 54.7638 27.5317 52.8034L38.0082 42.3675L38.2843 42.4484L48.641 52.8034C51.5994 54.7612 54.7791 51.5766 52.8233 48.6218L42.391 38.1415L42.4718 37.8648L52.4457 27.9066C53.9535 26.5335 53.5785 23.3098 51.4275 22.8609Z",
    fill: "#8286AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5513_9673"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRates);
export default __webpack_public_path__ + "static/media/no-rates.81a6f3c12edc9dada27c2ddd59cc6427.svg";
export { ForwardRef as ReactComponent };